import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import NewActivities from "./NewActivities";
import ActiveActivities from "./ActiveActivities";
import styles from "../notification/NotifySurface.module.css";

const Activity: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [activeTab, setActiveTab] = useState<"newActivity" | "activeActivities">("newActivity");

    const handleTabClick = (tab: "newActivity" | "activeActivities") => {
        setActiveTab(tab);
    };

    return (
        <div className={styles.root}>
            <div className={styles.page}>
                <div className={styles.pageTitle}>
                    <TitleSubtitle title={t("activity")} subtitle={t("activitySub")} />
                </div>

                <div className={styles.stepDescription}>
                    <div className={styles.tabs}>
                        <div
                            className={`${styles.tab} ${activeTab === "newActivity" ? styles.tabActive : ""}`}
                            onClick={() => handleTabClick("newActivity")}
                        >
                            {t("newActivity")}
                        </div>
                        <div
                            className={`${styles.tab} ${activeTab === "activeActivities" ? styles.tabActive : ""}`}
                            onClick={() => handleTabClick("activeActivities")}
                        >
                            {t("activeActivities")}
                        </div>
                    </div>

                    {activeTab === "newActivity" && (
                        <div>
                            <NewActivities setActiveTab={setActiveTab} />
                        </div>
                    )}

                    {activeTab === "activeActivities" && (
                        <div>
                            <ActiveActivities />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Activity;
